import React from 'react';
import { useStyles } from './styles';
import { Box, Typography, Button  } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

export const PaymentAmountRestriction = (props) => {

  const theme = useTheme()
  const classes = useStyles();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog fullScreen={fullScreen} PaperProps={{ classes: { root: classes.dialogStyle } }} open={true} onClose={props.handleClose}>
      <Box className={classes.root}>
        <IconButton onClick={props.handleClose} className={classes.closeIcon}>
          <CancelIcon />
        </IconButton> 
        <Box className={classes.cardBody}>
          <Typography className={classes.statusTitle}>Action Required</Typography>
        </Box>
        <Box className={classes.cardBody}>
           <p className={classes.statusSubTitle}>Payment amount is $0.00. Please enter an amount greater than $0.00.</p>
          <Box className={classes.cardFooter}>
          <Button
            variant='contained'
            color='primary'
            className={classes.btn}
            onClick={() => props.handleClose()}
            >OK</Button>
        </Box>
        </Box>
      </Box>
    </Dialog>
  )
}
